import _ from 'lodash'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Breadcrumb } from '../../../models/interfaces/breadcrumb.interface'
import { storageBreadcrumbLoad, storageBreadcrumbSave } from '../../../storage/storageBreadcrumb'

const BreadcrumbsAction: string = 'Breadcrumbs'

interface InitialState {
  breadcrumb: Breadcrumb[]
}

const initialState: InitialState = {
  breadcrumb: storageBreadcrumbLoad()
}

const containsObject = (item: Breadcrumb, tempArray: Breadcrumb[]) => {
  for (let i = 0; i < tempArray.length; i++) {
    if (_.isEqual(tempArray[i].path, item.path)) {
      return i
    }
  }
  return -1
}

export const breadcrumbSlice = createSlice({
  name: BreadcrumbsAction,
  initialState,
  reducers: {
    initialBreadcrumb: (state, action: PayloadAction<Breadcrumb>) => {
      state.breadcrumb = [action.payload]
      storageBreadcrumbSave([action.payload])
    },
    addBreadcrumb: (state, action: PayloadAction<Breadcrumb>) => {
      const qtdObjects = containsObject(action.payload, state.breadcrumb)
      if (qtdObjects >= 0) {
        state.breadcrumb.length = qtdObjects + 1
      } else {
        state.breadcrumb.push(action.payload)
      }
      storageBreadcrumbSave(state.breadcrumb)
    }
  }
})

export default breadcrumbSlice.reducer
